"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintLogService = void 0;
var inversify_1 = require("inversify");
var IPrintLogService_1 = require("./IPrintLogService");
var PrintLogService = /** @class */ (function () {
    function PrintLogService() {
        this.enabled = false;
        this.level = IPrintLogService_1.LogLevel.Info;
    }
    PrintLogService.prototype.messagePrefix = function () {
        return "[event-tracking]: ";
    };
    PrintLogService.prototype.log = function (type) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.enabled && type >= this.level) {
            // LogLevel[this.level] 实际会获取到字符串
            var key = IPrintLogService_1.LogLevel[this.level].toLowerCase();
            // eslint-disable-next-line no-console
            var fn = console[key];
            if (fn && typeof fn === "function") {
                // @ts-expect-error TODO: fix typing
                fn.apply(void 0, __spreadArray([this.messagePrefix()], args, false));
            }
        }
    };
    PrintLogService.prototype.setLevel = function (level) {
        this.level = level;
    };
    PrintLogService.prototype.setEnabled = function (enabled) {
        this.enabled = enabled;
    };
    PrintLogService.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log.apply(this, __spreadArray([IPrintLogService_1.LogLevel.Info], args, false));
    };
    PrintLogService.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log.apply(this, __spreadArray([IPrintLogService_1.LogLevel.Warn], args, false));
    };
    PrintLogService.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.log.apply(this, __spreadArray([IPrintLogService_1.LogLevel.Error], args, false));
    };
    PrintLogService = __decorate([
        (0, inversify_1.injectable)()
    ], PrintLogService);
    return PrintLogService;
}());
exports.PrintLogService = PrintLogService;
